import { makeStyles, withStyles, styled, TextField } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  annoAndCommBar: {
    '& .MuiSwitch-track': {
      border: '1px solid white',
    },
    '& .MuiSwitch-thumb': {
      border: '1px solid white',
    },
  },
}));
